// Modal
export const RESET_VALUES = 'RESET_VALUES';

export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';



// WEBPACK FOOTER //
// ./src/actions/modal-actions.js